var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-notification",
      class: _vm.type,
      attrs: { "data-ci": _vm.dataCi }
    },
    [
      _c(
        "div",
        { staticClass: "page-notification__icon" },
        [_c("i8-icon", { attrs: { icon: _vm.icon } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "page-notification__message" }, [
        _c("span", [_c("strong", [_vm._v(_vm._s(_vm.name))])]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.messages, function(message, index) {
            return _c("li", { key: "msg--" + index }, [
              _vm._v("\n                " + _vm._s(message) + "\n            ")
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c9999f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c9999f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/PageNotification.vue
// module id = JYuV
// module chunks = 0 1